export enum UserModelsRoutes {
  GetModel = 'get-model',
  PublishModel = 'publish-model',
}
